<div fxFill *ngIf="dedicatedControl">
  <ng-container *ngIf="treeData && treeData.length;else NoResult">
    <flex-tree-input #treeDedicated [formControl]="dedicatedControl" [nodes]="treeData" [showFilter]="true"></flex-tree-input>
  </ng-container>

  <ng-template #NoResult>
    {{ 'public.message.no_item'|translate }}
  </ng-template>
</div>
